function adapter() {
  const dp = document.documentElement.clientWidth;
  const rootFontSize = dp / 50;
  const fs = rootFontSize < 10 ? 10 : rootFontSize > 16 ? 16 : rootFontSize;
  document.documentElement.style.fontSize = fs + "px";
}
adapter();
window.onresize = adapter;
